import { api } from './client'

export const gamesApi = {
    // Returns { games, pending_invitations }
    listGames: () => api.get('/games'),

    getGame: (gameId) => api.get(`/games/${gameId}`),

    createGame: () => api.post('/games', {}),

    invitePlayer: (gameId, username) =>
        api.post(`/games/${gameId}/invite`, { username }),

    respondToInvitation: (invitationId, accept) =>
        api.post(`/games/invitations/${invitationId}/respond`, { accept }),

    startGame: (gameId) => api.post(`/games/${gameId}/start`, {}),

    cancelGame: (gameId) => api.delete(`/games/${gameId}`),

    joinByCode: (code) => api.post(`/games/join/${code}`, {}),

    topTenGames: ({ myGames = false, firstName = '', lastName = '', city = '' } = {}) => {
        const params = new URLSearchParams()
        if (myGames) params.append('my_games', 'true')
        if (firstName) params.append('first_name', firstName)
        if (lastName)  params.append('last_name',  lastName)
        if (city)      params.append('city',        city)
        const qs = params.toString()
        return api.get(`/games/top-ten${qs ? `?${qs}` : ''}`)
    },
}
